import {
  CREATE_SITE_MAINTENANCE_LOG,
  EDIT_SITE_MAINTENANCE_LOG,
  RECEIVE_SITE_MAINTENANCE_LOGS,
  REQUEST_SITE_MAINTENANCE_LOGS,
} from '@sophocles/entities/SiteMaintenanceLog/siteMaintenanceLogActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_SITE_MAINTENANCE_LOGS:
      return action.siteMaintenanceLogs;
    case REQUEST_SITE_MAINTENANCE_LOGS:
    case EDIT_SITE_MAINTENANCE_LOG:
    case CREATE_SITE_MAINTENANCE_LOG:
    default:
      return state;
  }
}

export function siteMaintenanceLogReducer(state = Map(), action) {
  switch (action.type) {
    case RECEIVE_SITE_MAINTENANCE_LOGS:
    case REQUEST_SITE_MAINTENANCE_LOGS:
    case EDIT_SITE_MAINTENANCE_LOG:
    case CREATE_SITE_MAINTENANCE_LOG:
      return state.merge(getState(state, action));
    default:
      return state;
  }
}
